NewArticleController.$inject = ['ArticleService', 'AppService', '$uibModal', '$transitions', '$scope']

export default function NewArticleController(ArticleService, AppService, $uibModal, $transitions, $scope) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  vm.article = ArticleService.initArticle()

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.article.isPromoted = !vm.article.isPromoted
  }
  vm.setPublished = function() {
    vm.article.isPublished = !vm.article.isPublished
  }
  $transitions.onBefore({}, () => {
    if (!vm.cancelled && !$scope.pristine.isPristine()) return ArticleService.postArticle(vm.article)
  }, {invokeLimit: 1})
}